import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useInView } from 'react-intersection-observer';
import { faCommentDots } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { Item, Select } from '@components/basics/RadixSelect';
import type { UserNft } from '@hooks/useMultipleNftsForRelease';

export function EditionSelector({
  selectedIndex,
  setSelectedIndex,
  nfts,
  loadMore,
}: {
  selectedIndex: number;
  setSelectedIndex: (index: number) => void;
  nfts: UserNft[];
  loadMore: () => void;
}) {
  const [bottomRef, isAtBottom] = useInView({
    threshold: 0.1,
  });

  useEffect(() => {
    if (isAtBottom) {
      loadMore();
    }
  }, [isAtBottom, loadMore]);

  const commentedChip = (
    <div className="flex items-center justify-between gap-[7px] rounded-[24px] bg-brand50 px-2 py-[2px] text-[13px] font-medium text-brand800">
      <FontAwesomeIcon icon={faCommentDots} size="lg" />
      <p>Commented</p>
    </div>
  );

  return (
    <div className="grid w-full gap-4">
      <div className="text-base-m font-semibold md:text-base-l">Select Edition</div>
      <Select
        value={selectedIndex.toString()}
        onValueChange={value => {
          setSelectedIndex(parseInt(value));
        }}
        triggerCss={{
          '> span:first-child': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          },
        }}
      >
        {nfts &&
          nfts.map((nft, index) => {
            return (
              <Item key={nft.id} value={index.toString()} showIcon={false}>
                <div className="flex items-center">#{nft.serialNumber.toString()}</div>
                <div className="mr-[10px] flex justify-end gap-2 text-right">
                  {nft.comment?.id && commentedChip}
                </div>
              </Item>
            );
          })}
        <div ref={bottomRef} />
      </Select>
    </div>
  );
}
